module.exports = __webpack_public_path__ + "img/instagram.1cb2240e.svg";